export type EcommerceRule = {
    ruleKey: string
    ruleType: string
    enabled: boolean
    values: string[]
    deleted: boolean
}

export type EcommerceRulesSetDto = {
    rules: EcommerceRule[]
    cssSelectors: string
    enabled: boolean
}

export interface EcommerceRulesSet {
    showAddToQuoteRules: EcommerceRulesSetDto,
    hidePricesRules: EcommerceRulesSetDto,
    hideAddToCartButtonRules: EcommerceRulesSetDto
}

const SEPARATOR = "/"
const OBJECT_TYPE_PRODUCT = "product"

export namespace ECOMMERCE_RULE_VALUE_TYPE {
    export const VALUE_TYPE_STRING = "string"
    export const VALUE_TYPE_NUMBER = "number"
    export const VALUE_TYPE_BOOLEAN = "boolean"
    export const VALUE_TYPE_DATE = "date"
}
export type ECOMMERCE_RULE_VALUE_TYPE = typeof ECOMMERCE_RULE_VALUE_TYPE[keyof typeof ECOMMERCE_RULE_VALUE_TYPE];

export const getEcommerceRuleValueType = (ruleKey: string): string => {
    const values = ruleKey.split(SEPARATOR)
    if (values.length > 2) {
        return values[2]
    }

    return ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING
}

export namespace ECOMMERCE_RULE_KEY {
    export const PRODUCT_TAGS = OBJECT_TYPE_PRODUCT + SEPARATOR + "tags" + SEPARATOR +
        ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING
    export const PRODUCT_TYPES = OBJECT_TYPE_PRODUCT + SEPARATOR + "types" + SEPARATOR +
        ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING
    export const PRODUCT_IDS = OBJECT_TYPE_PRODUCT + SEPARATOR + "ids" + SEPARATOR +
        ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING
    export const PRODUCT_NAMES = OBJECT_TYPE_PRODUCT + SEPARATOR + "names" + SEPARATOR +
        ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING
    export const PRODUCT_SKUS = OBJECT_TYPE_PRODUCT + SEPARATOR + "skus" + SEPARATOR +
        ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_STRING
    export const PRODUCT_AVAILABILITY = OBJECT_TYPE_PRODUCT + SEPARATOR + "availability" +
        SEPARATOR + ECOMMERCE_RULE_VALUE_TYPE.VALUE_TYPE_BOOLEAN
}
export type ECOMMERCE_RULE_KEY = typeof ECOMMERCE_RULE_KEY[keyof typeof ECOMMERCE_RULE_KEY];

export const ECOMMERCE_RULE_KEYS = [
    ECOMMERCE_RULE_KEY.PRODUCT_TAGS,
    ECOMMERCE_RULE_KEY.PRODUCT_TYPES,
    ECOMMERCE_RULE_KEY.PRODUCT_IDS,
    ECOMMERCE_RULE_KEY.PRODUCT_NAMES,
    ECOMMERCE_RULE_KEY.PRODUCT_SKUS,
    ECOMMERCE_RULE_KEY.PRODUCT_AVAILABILITY,
]

export namespace ECOMMERCE_RULE_TYPE {
    export const RULE_TYPE_INCLUDES_ONE_OF = "includes-one-of"
    export const RULE_TYPE_INCLUDES_ALL = "includes-all"
    export const RULE_TYPE_EXCLUDES_ALL = "excludes-all"
    export const RULE_TYPE_CONTAINS_ONE_OF = "contains-one-of"
    export const RULE_TYPE_CONTAINS_ALL = "contains-all"
    export const RULE_TYPE_NOT_CONTAINS_ALL = "not-contains-all"
    export const RULE_TYPE_IS_TRUE_OR_FALSE = "is-true-or-false"
    export const RULE_TYPE_START_WITH_ONE_OF = "start-with-one-of"
    export const RULE_TYPE_NOT_START_WITH_ALL = "not-start-with-all"
    export const RULE_TYPE_END_WITH_ONE_OF = "end-with-one-of"
    export const RULE_TYPE_NOT_END_WITH_ALL = "not-end-with-all"
}
export type ECOMMERCE_RULE_TYPE = typeof ECOMMERCE_RULE_TYPE[keyof typeof ECOMMERCE_RULE_TYPE];


export const ECOMMERCE_RULE_TYPES_STRING = [
    ECOMMERCE_RULE_TYPE.RULE_TYPE_INCLUDES_ONE_OF,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_INCLUDES_ALL,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_EXCLUDES_ALL,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_CONTAINS_ONE_OF,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_CONTAINS_ALL,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_NOT_CONTAINS_ALL,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_START_WITH_ONE_OF,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_NOT_START_WITH_ALL,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_END_WITH_ONE_OF,
    ECOMMERCE_RULE_TYPE.RULE_TYPE_NOT_END_WITH_ALL,
]

export const ECOMMERCE_RULE_TYPES_BOOLEAN = [
    ECOMMERCE_RULE_TYPE.RULE_TYPE_IS_TRUE_OR_FALSE,
]


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceRule.ts